<template>
  <div class="col-md-6">
    <contact-details :report="report" showAnchor="true" :showWebsite="true"></contact-details>
    <social-media :report="report" showAnchor="true"></social-media>
    <open-directorships :diff-data="diffData" :report="report" :show-diff="showDiff" />
    <sanctions v-if="report.includes_sanctions" :report="report"></sanctions>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ContactDetails from '@/components/reports/panels/ContactDetails';
import SocialMedia from '@/components/reports/panels/SocialMedia';
import OpenDirectorships from '@/components/reports/panels/OpenDirectorships';
import HseCases from '@/components/reports/panels/HseCases';
import Sanctions from '@/components/reports/panels/Sanctions';

export default {
  components: {
    ContactDetails,
    SocialMedia,
    OpenDirectorships,
    HseCases,
    Sanctions,
  },
  mixins: [toolsMixin],
  props: ['diffData', 'report', 'showDiff'],
};
</script>
